import {useLocation} from '@github-ui/react-router'
import {useMemo} from 'react'

import {readBoardParams} from '../../utils/board-url-params'

// This component only proves that the layout switch works end to end and that
// arrangement is read from named URL params — never from `q`.
export function SavedViewBoard({owner, repo, query}: {owner: string; repo: string; query: string}) {
  const {search} = useLocation()
  const params = useMemo(() => readBoardParams(new URLSearchParams(search)), [search])

  return (
    <div data-testid="saved-view-board">
      <p>Board view</p>
      <ul>
        <li>
          Repo: <code>{`${owner}/${repo}`}</code>
        </li>
        <li>
          Query: <code>{query ?? '—'}</code>
        </li>
        <li>
          Group by: <span>{params.groupBy ?? '—'}</span>
        </li>
        <li>
          Swimlane by: <span>{params.swimlaneBy ?? '—'}</span>
        </li>
        <li>
          Sort: <span>{params.sort ?? '—'}</span>
        </li>
      </ul>
    </div>
  )
}
